import React from 'react';
import { useTranslation } from 'react-i18next';
import { IProduct } from '../../../../../types/types';
import Button from '../../../../../../../../generic-components/Button';
import { ReactComponent as ClearIcon } from '../../../../../../../../assets/icons/svg/shared/ic-shared-clear.svg';
import { TEXTS } from '../../../../../consts/consts';

export const itemDescriptionTemplate = (item: IProduct, onChange: (item: IProduct) => void) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-col items-start justify-center h-[64px] hover:${item.serviceItemId ? 'bg-bw0' : 'bg-bw02'} `}
    >
      {item.serviceItemId ? (
        <p
          title={item.description}
          className='font-metricR text-[14px] text-bw07 text-left overflow-y-scroll p-[12px] max-w-[30ch] truncate'
        >
          {item.description}
        </p>
      ) : (
        <div className='flex flex-row justify-between w-full  h-full py-[10px] px-[12px]'>
          <input
            value={item.description}
            className='font-metricR text-[14px] text-bw08 w-full h-full outline-none bg-transparent resize-none  placeholder:text-bw06'
            placeholder={t(TEXTS.INVOICE_CREATION.INVOICE_SERVICES_SECTION.DESCRIPTION_INPUT_PLACEHOLDER)}
            onChange={(e) => {
              item.description = e.target.value.length > 200 ? item.description : e.target.value;
              onChange(item);
            }}
          />
          {item.description.length > 0 && (
            <Button
              className=''
              id='clear_button'
              childElement={<ClearIcon />}
              onClick={() => {
                item.description = '';
                onChange(item);
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};
